/* global document */
'use strict';

import log from '../logger';
import event from '../event';

export default function load(files, cb) {
    const scripts = document.querySelectorAll('script');
    const scriptsMap = {};
    const pendingScripts = [];
    const firstScript = document.scripts[0];
    let downloadCount = 0;
    let error;

    for (let i = 0; i < scripts.length; i++) {
        const script = scripts[i];

        if (script.src) {
            scriptsMap[script.src] = true;
        }
    }

    // exclude any scripts already in the DOM (e.g. another fragment imported the same vendors)
    const filesToDownload = files.filter((file) => !scriptsMap[file.url]);

    if (filesToDownload.length === 0) {
        cb();
        return;
    }

    filesToDownload.forEach((file) => {
        const script = document.createElement('script');

        script.type = 'text/javascript';
        script.charset = 'UTF-8';
        script.crossOrigin = 'anonymous';
        script.onerror = (err) => {
            doCallback(err, file);
        };
        script.onload = () => {
            doCallback(null, file);
        };

        if ('async' in firstScript) {
            script.async = false;
            script.src = file.url;

            document.head.appendChild(script);
        } else {
            log.debug('scriptLoader(): load script in order');

            // IE < 10
            // create a script and add it to the pending list
            pendingScripts.push(script);
            // listen for state changes
            script.onreadystatechange = stateChange;

            // must set src AFTER adding onreadystatechange listener
            // else we’ll miss the loaded event for cached scripts
            script.src = file.url;
            script.file = file;
        }
    });

    /**
     * IE < 10 does not load scripts in order when they are added to the DOM.
     * References:
     * https://www.html5rocks.com/en/tutorials/speed/script-loading
     * https://stackoverflow.com/questions/1834077/which-browsers-support-script-async-async
     * https://developer.mozilla.org/en/docs/Web/HTML/Element/script#Browser_compatibility
     */
    function stateChange() {
        while (pendingScripts[0] && pendingScripts[0].readyState === 'loaded') {
            const pendingScript = pendingScripts.shift();

            // avoid future loading events from this script (eg, if src changes)
            pendingScript.onreadystatechange = null;
            // can't just appendChild, old IE bug if element isn't closed
            firstScript.parentNode.insertBefore(pendingScript, firstScript);

            doCallback(null, pendingScript.file);
        }
    }

    function doCallback(err, file) {
        downloadCount++;
        error = err || error;
        event.trigger(err ? 'error.file.js' : 'load.file.js', {error: err, file});

        if (downloadCount === filesToDownload.length) {
            cb(error);
        }
    }
}
